<div class="content">
  <span class="mat-title"> Financeiro </span>
  <mat-progress-bar *ngIf="submiting" mode="indeterminate"></mat-progress-bar>
  
  <mat-divider></mat-divider>

  <ng-container>
    <h3 style="margin-top:10px"><strong>Informações de Pagamento</strong></h3>
    <span>
      <span class="plan-container">Plano Empresarial</span> 
      <span class="plan-type">{{ getPlanDetails().name }}</span>
      <span class="plan-value">
        {{ getPlanDetails().price }}
      </span>
      <span class="mat-body-1 plan-active" *ngIf="user.signature_status === 'ACTIVE'">Seu plano está ativado</span>
    </span>
    <span class="mat-body-1 plan-trial" *ngIf="user.signature_status === 'TRIAL' && trialDate > 0">
      Seu período de teste termina em <strong>{{ trialDate }} dias</strong>
    </span>
    <span class="mat-body-1 plan-trial-end" *ngIf="user.signature_status === 'TRIAL' && trialDate == 0">
      Período de teste <strong> encerrado.</strong>
    </span>
    <span class="mat-body-1 plan-pending" *ngIf="user.signature_status === 'PENDING'">
      Seu plano está Pendente
    </span>
    <span class="mat-body-1 plan-cancel" *ngIf="user.signature_status === 'CANCELED'">
      Seu plano está Cancelado
    </span>
    <!--<button mat-stroked-button color="primary">Alterar plano</button>--> 
    <ng-container *ngIf="user.signature_status !== 'ACTIVE'">
      <button
        mat-button
        mat-raised-button
        class="custom-primary"
        [routerLink]="['/recruiter/payment']"
        style="margin-left: 15px;"
      >
        Ativar Conta
      </button>
    </ng-container>
    <ng-container *ngIf="!cancel; else loadingCancel">
      <!-- <ng-container *ngIf="user.signature_status === 'ACTIVE'">
                <div>
                    <button mat-stroked-button color="primary" (click)="openCheckout()">Alterar plano/meio de pagamento</button>
                </div>
            </ng-container> -->
        <ng-container *ngIf="user.signature_status === 'ACTIVE'">
          <button mat-stroked-button color="warn" (click)="cancelSignature()" style="margin-left: 15px;">
            Cancelar plano
          </button>
        </ng-container>
    </ng-container>
    <ng-template #loadingCancel>
      <div class="">
        <p class="mat-body-2">Cancelamento em progresso</p>
      </div>
    </ng-template>

    <div class="mat-body-2" *ngIf="historic" style="margin-top: 20px;">
      <table mat-table [dataSource]="dataSource" matSort class="mat-table">
        
        <!-- Coluna Banco -->
        <ng-container matColumnDef="bank">
          <th mat-header-cell *matHeaderCellDef> Banco </th>
          <td mat-cell *matCellDef="let element">
            <img src="assets/images/banco-efi.png" alt="Efi Bank" width="50" height="40">
          </td>
        </ng-container>

        <!-- Coluna Tipo de Pagamento -->
        <ng-container matColumnDef="charge_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Fatura </th>
          <td mat-cell *matCellDef="let element"> {{element.charge_id}} </td>
        </ng-container>

        <!-- Coluna Tipo de Pagamento -->
        <ng-container matColumnDef="payment_type">
          <th mat-header-cell *matHeaderCellDef> Tipo de Pagamento </th>
          <td mat-cell *matCellDef="let element"> Boleto </td>
        </ng-container>

        <!-- Coluna Created At -->
        <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Criado em </th>
        <td mat-cell *matCellDef="let element"> {{formatDate(element.created_at)}} </td>
        </ng-container>

        <ng-container matColumnDef="expire_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Vencimento </th>
          <td mat-cell *matCellDef="let element">
            {{ element.expire_at ? (element.expire_at | date: 'dd/MM/yyyy') : 'N/A' }}
          </td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let element">
            <div [ngClass]="getStatusClass(element.status)"
                  style="color: white; border-radius: 36px; padding: 4px 8px;">
              {{translateStatus(element.status)}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef> Ações </th>
          <td mat-cell *matCellDef="let element">
            <a
              *ngIf="element.status !== 'paid' && element.status !== 'waiting'"
              mat-stroked-button
              color="primary"
              [href]="element.pdf"
              target="_blank">
              <mat-icon>request_quote</mat-icon> 2ª via
            </a>
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="openHistoryDialog(element.history); $event.stopPropagation()">
              <mat-icon>history</mat-icon> Detalhes
            </button>          
          </td>
        </ng-container>
    
        <!-- Header e Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openPdf(row.pdf)"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>  
  </ng-container>
  
  <div class="historic" style="margin-top: 10px;">
    <div class="empty-content" *ngIf="!historic">
        <span class="mat-body-2">Não há histórico de pagamentos</span>
    </div>
  </div>

</div>
